import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import ChecklistItemTranslated from '../../common/ChecklistItemTranslated';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
const intentSignals = 'intentSignals';
const monitorCompanies = 'monitorCompanies';
const dataAgent = 'dataAgent';
const conversations = 'conversations';
const breezeActions = 'breezeActions';
const monitorContacts = 'monitorContacts';
const deepResearch = 'deepResearch';
const dataSync = 'dataSync';
export const getValueProps = screen => {
  switch (screen) {
    case NavItemEnum.SUITE:
      return [intentSignals, monitorCompanies, dataAgent];
    case NavItemEnum.MARKETING:
      return [conversations, intentSignals, monitorCompanies, dataAgent, breezeActions];
    case NavItemEnum.SALES:
      return [monitorContacts, deepResearch, conversations, intentSignals, monitorCompanies];
    case NavItemEnum.SERVICE:
      return [conversations, dataAgent, breezeActions];
    case NavItemEnum.CONTENT:
      return [conversations, intentSignals, monitorCompanies, dataAgent];
    case NavItemEnum.DATA:
      return [intentSignals, monitorCompanies, dataAgent, dataSync];
    case NavItemEnum.COMMERCE:
      return [conversations, dataAgent];
    case NavItemEnum.MARKETING_PLUS:
      return [conversations, intentSignals, monitorCompanies, dataAgent, breezeActions];
    default:
      return [];
  }
};
export const CreditsFeatures = ({
  size,
  isCollapsible = false,
  loading,
  subscreen
}) => {
  const HeaderSection = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `merchCards.hubSpotCredits.${size}.valueProps.title`
  });
  const valuePropsKeys = getValueProps(subscreen);
  const FeaturesListSection = valuePropsKeys.map((valuePropKey, index) => {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: index > 0 ? '300' : undefined,
      children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `merchCards.hubSpotCredits.${size}.valueProps.${valuePropKey}`
        })
      })
    }, valuePropKey);
  });
  if (!valuePropsKeys.length) return null;
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};